import Vue from 'vue'
import Vuex from 'vuex'
import BackendService from '../services/requests/backendService'
Vue.use(Vuex)

const meusAgendamentosStore = new Vuex.Store({
  state: {
    loading: false,

    agendas: [],
    loadingAgendas:false,

  },
  mutations: {
    setLoading(state, value) { state.loading = value },
    
    setAgendas(state, value) { state.agendas = value },
    setLoadingAgendas(state, value) { state.loadingAgendas = value },
    
  },
  getters:{
    isLoading(state){
      return state.loadingAgendas
    }
  },
  actions: {
    get_minhas_agendas: async (context, params)=>{
      const req = new BackendService()
      context.commit('setLoadingAgendas', true)
      return await req.get_agendamentos(params)
      .then( response => { 
        context.commit('setAgendas', response.data)
      }).catch( error => { 
        console.log(error.response); 
      }).finally( () => { 
        context.commit('setLoadingAgendas', false) 
      })
    },
  }
})

export default meusAgendamentosStore
